import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Grid, TextField, Button, Box, Typography, InputAdornment } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import SaveIcon from "@mui/icons-material/Save";
import PinDropIcon from "@mui/icons-material/PinDrop";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import "./CreateSite.css";
import axios from "axios";
import apiService from "../../utils/apiservice";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";


const CreateSite = () => {
  const [siteData, setSiteData] = useState({
    name: "",
    customer_id: "",
    latitude: "",
    longitude: "",
    survey_no: "",
    address: "",
    pin_code: "",
    society_reg_no: "",
    // asset_id: "",
  });
  const [errors, setErrors] = useState({});
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_DJANGO_URL;


  //   const validateForm = () => {
  //   const tempErrors = {};
  //   const { name, society_reg_no, survey_no, pin_code, latitude, longitude } = siteData;

  //   if (
  //   !name ||
  //   !/^[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$/.test(name) ||
  //   name.length < 2 ||
  //   name.length > 20
  // ) {
  //   tempErrors.name = "Site Name must be 2-20 characters, alphanumeric, and may include one space between words.";
  // }

  //   if (!society_reg_no || !/^[a-zA-Z0-9/-]{2,15}$/.test(society_reg_no)) {
  //   tempErrors.society_reg_no = "Society Reg No must be 2-15 characters and can include letters, numbers, / and - only.";
  // }
  //   if (!survey_no || !/^[a-zA-Z0-9\s\/-]{2,20}$/.test(survey_no)) {
  //   tempErrors.survey_no = "Survey No must be 2-20 characters and can include letters, numbers, spaces, / and - only.";
  // }


  //   if (!pin_code || !/^\d{6}$/.test(pin_code)) {
  //     tempErrors.pin_code = "Pin Code must be exactly 6 digits.";
  //   }

  //   if (!latitude || isNaN(latitude) || latitude < -90 || latitude > 90) {
  //     tempErrors.latitude = "Latitude must be between -90 and 90.";
  //   }

  //   if (!longitude || isNaN(longitude) || longitude < -180 || longitude > 180) {
  //     tempErrors.longitude = "Longitude must be between -180 and 180.";
  //   }

  //   setErrors(tempErrors);

  //   return Object.keys(tempErrors).length === 0; // true if no errors
  // };



  const validateForm = (fieldName = null, fieldValue = null) => {
    const newErrors = { ...errors }; // copy current errors

    const fieldsToCheck = fieldName
      ? { [fieldName]: fieldValue }
      : { ...siteData };

    for (let key in fieldsToCheck) {
      const value = fieldsToCheck[key];

      if (key === "name") {
        // Must contain at least one letter, can have letters & numbers, optional single space between words
        const nameRegex = /^(?=.*[a-zA-Z])[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$/;

        if (!value || !nameRegex.test(value) || value.length < 2 || value.length > 30) {
          newErrors.name =
            "Site Name must be 2-30 characters, alphanumeric, contain at least one letter.";
        } else {
          delete newErrors.name;
        }
      }

      // if (key === "society_reg_no") {
      //   if (!value || !/^[a-zA-Z0-9/-]{2,15}$/.test(value)) {
      //     newErrors.society_reg_no = "Society Reg No must be 2-15 characters, numbers, / and - only.";
      //   } else {
      //     delete newErrors.society_reg_no;
      //   }
      // }

      if (key === "society_reg_no") {
        const zeroOnly = /^0+$/;

        if (
          !value ||
          !/^[a-zA-Z0-9/-]{2,15}$/.test(value) ||
          zeroOnly.test(value)
        ) {
          newErrors.society_reg_no =
            "Society Reg No must be 2-15 characters, and cannot be all zeros.";
        } else {
          delete newErrors.society_reg_no;
        }
      }

      if (key === "survey_no") {
        if (!value || !/^[a-zA-Z0-9\s\/-]{2,20}$/.test(value)) {
          newErrors.survey_no = "Survey No must be 2-20 characters and can include letters, numbers, spaces, / and - only.";
        } else {
          delete newErrors.survey_no;
        }
      }

      if (key === "pin_code") {
        if (!/^\d{6}$/.test(value)) {
          newErrors.pin_code = "Pin Code must be exactly 6 digits.";
        } else {
          delete newErrors.pin_code;
        }
      }

      if (key === "latitude") {
        const latRegex = /^-?([0-8]?\d|90)(\.\d{1,6})?$/;

        if (!value) {
          newErrors.latitude = "Latitude is required.";
        } else if (!latRegex.test(value)) {
          newErrors.latitude =
            "Latitude must be between -90 and 90 with up to 6 decimal places.";
        } else {
          delete newErrors.latitude;
        }
      }

      if (key === "longitude") {
        const longRegex = /^-?((1[0-7]\d)|([1-9]?\d)|180)(\.\d{1,6})?$/;

        if (!value) {
          newErrors.longitude = "Longitude is required.";
        } else if (!longRegex.test(value)) {
          newErrors.longitude =
            "Longitude must be between -180 and 180 with up to 6 decimal places.";
        } else {
          delete newErrors.longitude;
        }
      }
      if (key === "address") {
        // Address is optional
        if (!value || value.trim() === "") {
          delete newErrors.address;
        } else {
          // Allowed characters
          const addressRegex = /^[a-zA-Z0-9\s,./-]{5,100}$/;

          // Must contain at least one letter
          const hasLetter = /[a-zA-Z]/;

          if (
            !addressRegex.test(value) ||
            !hasLetter.test(value)
          ) {
            newErrors.address =
              "Address must contain at least one letter and can include 5-100 characters.";
          } else {
            delete newErrors.address;
          }
        }
      }
    }



    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   setSiteData((prev) => ({ ...prev, [name]: value }));

  //    validateForm(name, value);
  // };

  const handleChange = (e) => {
    let { name, value } = e.target;

    if (name === "name" || name === "survey_no" || name === "society_reg_no" || name === "pin_code" || name === "address") {
      // 1. Prevent leading space: If the first character is a space, clear it
      if (value.startsWith(" ")) {
        value = value.trimStart();
      }

      // 2. Prevent consecutive spaces: Replace two or more spaces with one space
      value = value.replace(/\s{2,}/g, " ");
    }

    setSiteData((prev) => ({ ...prev, [name]: value }));

    // Run validation on the processed value
    validateForm(name, value);
  };



  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await apiService({
          url: "/api/get_customers/",
          method: "GET",
        });

        const customerData = response?.data?.data || response?.data || [];

        setCustomers(customerData);

        // Auto-select first customer
        // if (customerData.length > 0) {
        //   const firstCustomerId = customerData[0].tb_customer_id;

        //   setSelectedCustomer(firstCustomerId);

        //   // also bind inside payload state
        //   setSiteData((prev) => ({
        //     ...prev,
        //     customer_id: firstCustomerId,
        //   }));
        // }
        if (customerData.length > 0) {
          setCustomers(customerData);
        }
      } catch (error) {
        console.error("Error fetching customers:", error);
        toast.error("Failed to load customers");
        setCustomers([]);
      }
    };

    fetchCustomers();
  }, []);


  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const token = localStorage.getItem("accessToken"); // ensure token exists
      if (!token) {
        toast.error("No token found! Please login first.");
        return;
      }

      // const response = await axios.post(
      //   `${API_URL}/api/create_site/`, // using env variable
      //   siteData,
      //   {
      //     headers: {
      //       "Content-Type": "application/json",
      //       Accept: "application/json",
      //       Authorization: `Bearer ${token}`,
      //     },
      //   }
      // );
      const response = await apiService({
        url: "/api/create_site/",
        method: "POST",
        data: siteData,
      });


      console.log("Site created:", response.data);
      toast.success("Site created successfully!");
      setSiteData({
        name: "",
        // customer_id: "",
        latitude: "",
        longitude: "",
        survey_no: "",
        address: "",
        pin_code: "",
        society_reg_no: "",
        // asset_id: "",
      });

    } catch (error) {
      console.error("Error creating site:", error.response?.data || error.message);
      // toast.error(error.response?.data?.error || "Failed to create site"); 
      if (error.response?.status === 400) {
        toast.error("Site with this name already exists");
      } else {
        toast.error("Failed to create site");
      }

    }
  };

  return (
    <Box component="form" className="create-site-form-container" onSubmit={handleFormSubmit}>

      {/* 1. Remove direction="column" to allow side-by-side flow */}
      <Grid container spacing={3}>


        {/* 2. Use xs={12} sm={6} for all paired fields */}
        <Grid item xs={12} sm={6}>
          <TextField
            className="create-site-input"
            label="Site Name"
            name="name"
            value={siteData.name}
            onChange={handleChange}
            required
            error={!!errors.name} // true if error exists
            helperText={errors.name || ""} // show error text

          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControl fullWidth className="create-site-input">
            <InputLabel id="customer-label">Select Customer</InputLabel>

            <Select
              labelId="customer-label"
              value={selectedCustomer || ""}
              label="Select Customer"
              onChange={(e) => {
                const customerId = e.target.value;

                setSelectedCustomer(customerId);

                setSiteData((prev) => ({
                  ...prev,
                  customer_id: customerId || null, // allow empty
                }));
              }}
            >
              {/* <MenuItem value="">
                <em>None</em>
              </MenuItem> */}

              {customers.map((customer) => {
                const cId = customer.tb_customer_id;

                return (
                  <MenuItem key={cId} value={cId}>
                    {customer.customer_name}
                  </MenuItem>
                );
              })}
            </Select> <Typography
              variant="caption"
              sx={{ marginLeft: "4px", marginTop: "4px", color: "gray" }}
            >
              Optional
            </Typography>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <TextField
            className="create-site-input"
            label="Society Reg No"
            name="society_reg_no"
            value={siteData.society_reg_no}
            onChange={handleChange}
            required
            error={!!errors.society_reg_no}
            helperText={errors.society_reg_no || ""}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            className="create-site-input"
            label="Survey No"
            name="survey_no"
            value={siteData.survey_no}
            onChange={handleChange}
            required
            error={!!errors.survey_no}
            helperText={errors.survey_no || ""}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            className="create-site-input"
            label="Pin Code"
            name="pin_code"
            value={siteData.pin_code}
            onChange={handleChange}
            required
            error={!!errors.pin_code}
            helperText={errors.pin_code || ""}
          />
        </Grid>



        <Grid item xs={12} sm={6}>
          <TextField
            className="create-site-input"
            type="number"
            label="Latitude"
            name="latitude"
            value={siteData.latitude}
            onChange={handleChange}
            required
            error={!!errors.latitude}
            helperText={errors.latitude || ""}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LocationOnIcon color="action" />
                </InputAdornment>
              ),
            }}
          />
        </Grid>


        <Grid item xs={12} sm={6}>
          <TextField
            className="create-site-input"
            type="number"
            label="Longitude"
            name="longitude"
            value={siteData.longitude}
            onChange={handleChange}
            required
            error={!!errors.longitude}
            helperText={errors.longitude || ""}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PinDropIcon color="action" />
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        {/* Address: Usually looks better full width (xs={12}) even in 2-column forms */}
        <Grid item xs={12}>
          <TextField
            className="create-site-input"

            rows={2}
            label="Address"
            name="address"
            value={siteData.address}
            onChange={handleChange}
            error={!!errors.address} // show error if exists
            helperText={errors.address || "Optional field"}
          />
        </Grid>





      </Grid>

      <Box className="submit-btn-wrapper" display="flex"
        gap={2}
        mt={3}
      >
        <Button
          type="button"
          variant="outlined"
          // color="secondary"
          size="large"
          className="submit-btn cancel-btn"
          onClick={() => {
            // reset form and errors
            setSiteData({
              name: "",
              latitude: "",
              longitude: "",
              survey_no: "",
              address: "",
              pin_code: "",
              society_reg_no: "",
            });
            setErrors({});
            navigate("/dashboard");
          }}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          variant="contained"
          // startIcon={<SaveIcon />}
          size="large"
          className="submit-btn"
        >
          Create Site
        </Button>


      </Box>

      <ToastContainer position="top-right" autoClose={3000} theme="light" />
    </Box>
  );
};
export default CreateSite;